import { setup } from '@doltech/core/lib/api/api.config';
import { environment } from '@doltech/core/lib/environment/environment';

const localCache = {};

const apiWordChecker = setup({
  baseURL: environment.REACT_APP_WORD_CHECKER_API_HOSTNAME,
});

const fetchCheckWord = async ({ word1, word2 }) => {
  const cacheKey = `${word1}-${word2}`;
  if (localCache[cacheKey]) {
    return localCache[cacheKey];
  }
  const { data } = await apiWordChecker.get('/check/word/compare', {
    word1,
    word2,
  });
  localCache[cacheKey] = data;

  return data as any;
};

export const compareWord = async ({ word1, word2 }: { word1: string; word2: string }) => {
  if (!word1 || !word2) {
    return false;
  }

  const isExactlyEqual = word1.toLowerCase() === word2.toLowerCase();
  if (isExactlyEqual) {
    return true;
  }

  const isSimilar = await fetchCheckWord({ word1, word2 });
  if (isSimilar?.isEqual) {
    return true;
  }
  return false;
};
